<template>
  <div class="tahcloud_block" v-if="tags.length > 0">
    <div class="tags_div" :v-if="iscloudeBlock">
      <h3 class="h3cycx">常用查询:</h3>
      <div
        class="chaxunspan"
        ref="cloudBlock"
        id="searchBox"
        style="height:auto"
      >
        <span
          class="el-tag tages"
          @click="spantages(item)"
          v-for="(item, index) in tags"
          :key="index"
          >
          <el-tooltip class="item" effect="dark" :content="item.lableName" placement="top-start">
          
         <span class='tagesspan' >
            {{ item.lableName }}
       
        
          </span> 
             </el-tooltip>
          <span class=" tagesclose tagesclose_i" @click.stop="tageclose(item.id)">
            <i class=" el-icon-close "></i>
          </span>
        </span>
      </div>
    
      <div class="unwind" @click="unwinds" v-if="tags.length>8">
        <i :class="[pageUnwind ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i
        >{{ !pageUnwind ? "收起" : "查看全部" }}
      </div>
    </div>

    <!-- <div class="input_block"> -->
    <!-- <el-button>重置</el-button> -->
    <!-- <el-button type="primary" @click="save">保存</el-but ton> -->
    <!-- </div>/ -->
    <slot></slot>
  </div>
  <!-- 
    ***** @iscloudeBlock:true/false   是否显示云标签Block
        @isbuttonBlock:true/false  是否显示按钮
        @cloudTages


   -->
</template>
<script>
/**
 * @{page}   解释用途
 * @{iscloudeBlock}  是否显示云标签Block
 * @{isbuttonBlock}  是否显示按钮
 * 
 * @cloudTages 回填方法

 *
 * 等等
 *
 * */

import * as api from "@/api/text/text";
export default {
  name: "TagsCloud",
  data() {
    return {
      pageUnwind: false,
      pageUnwindHeight: 0,
      PageId: "",
      tags: []
    };
  },
  props: {
    iscloudeBlock: { type: Boolean },
    isbuttonBlock: { type: Boolean }
  },
  created() {
    this.getPageId();
  },

  mounted() {
    // if (
    //   this.$refs.cloudBlock && (this.$refs.cloudBlock.scrollHeight == this.$refs.cloudBlock.offsetHeight)
    // ) {
    //   this.pageUnwindshow = true;
    //   this.pageUnwind = 0;
    // }
    // console.log(this.$refs.cloudBlock.offsetHeight);
  },
  methods: {
    
    getPageId() {
      api.getRoutesId({ path: this.$route.path }).then(res => {
        this.PageId = res.data.data;
        this.getPageDate();
      });
    },
    getPageDate() {
      api.getLableList({ lableMenuId: this.PageId }).then(res => {
        this.tags = res.data.data;
      });
    },
    spantages(data) {
      this.$emit("cloudTages", JSON.parse(data.lableJson));
    },
    tageclose(id) {
      api.deleteLable({ id }).then(res => {
        this.$message({
          type: "success",
          message: res.data.msg
        });
        this.getPageDate();
      });

      // console.log(index);
    },
    unwinds() {
      this.pageUnwind = !this.pageUnwind;
      var searchBoxHeght = document.getElementById("searchBox");
      if (this.pageUnwind == false) {
        searchBoxHeght.style.height = "auto";
      } else {
        searchBoxHeght.style.height = 60 + "px";
      }
    },
    addsave(params, value) {
      let stringJson = JSON.stringify(params);
      let dats = {
        lableName: value,
        lableJson: stringJson,
        lableMenuId: this.PageId
      };
      // console.log(dats);
      api.addLable(dats).then(res => {
        // console.log(res);
        this.$message({
          type: "success",
          message: res.data.msg
        });
        this.getPageDate();
      });
    },
    save(params) {
      // console.log(params);
      if (!params) {
        this.$message({
          type: "error",
          message: "请填写查询"
        });
        return;
      }
      this.$prompt("名称", "保存", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          if (value == null) {
            this.$message({
              type: "error",
              message: "请输入"
            });
            return;
          }
          let stringJson = JSON.stringify(params);

          api
            .addLable({
              lableName: value,
              lableJson: stringJson,
              lableMenuId: this.PageId
            })
            .then(res => {
              // console.log(res);
              this.$message({
                type: "success",
                message: res.data.msg
              });
              this.getPageDate();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.tahcloud_block {
  margin: 8px 0;

  .tags_div {
    background: #ffffff;
    padding: 15px 0;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-bottom: 1px solid #a1a1a12b;
    border-radius: 4px ;
    .h3cycx {
      width: 80px;
      text-align: center;
      margin: 0 15px;
    }
  }
  .chaxunspan {
    // width: 80%;
    flex:1;
    // margin-left: 15px;
    height: 80px;
    overflow: hidden;
  }
  .tages {
    margin: 5px;
    cursor: pointer;
    position: relative; 
    background: none;
    border: 1px solid #ddd;
    color: #000000;
    padding: 0 15px;
  }
  .tagesspan{
    width: 80px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
  .tages:hover {
    background: #539fe7;
    border-color: #539fe7;
    color: #fff;
  }
  .tagesclose {
    display: flex;
    width: 20px;
    height:20px;
    position: absolute;
    top: -5px;
    right: -5px; 
    border-radius: 50%;
    z-index: 5;
    
    background: #fb6260;
  }
  .tagesclose_i {
    opacity: 0;
  }
  .tagesclose_i:hover {
    opacity: 1;
  }
  .el-tag .el-icon-close{
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 20px;
    width: 20px;
    line-height: 20px;
    vertical-align: middle;
    top: 0px; 
  right: 0px;
  }
  .unwind {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 15px ;
    i {
      margin-right: 8px;
      font-weight: bold;
    }
  }
  .input_block {
    margin-top: 25px;
    background: #ffffff;
    padding: 15px 0;
  }
}
</style>
